import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { primengImports } from '../../primengImports';
import { Router } from '@angular/router';
import { MainService } from '@services/utilities/main.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-notificacion-dialog',
  imports: [CommonModule, primengImports],
  templateUrl: './notificacion-dialog.html',
  styleUrl: './notificacion-dialog.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true
})
export class NotificacionDialog implements OnInit, OnDestroy {
  private mainService = inject(MainService);
  private router = inject(Router);
  private subscription: Subscription = new Subscription();

  @Input() visible: boolean = false;
  @Input() title: string = 'Notificación';
  @Input() message: string = 'Mensaje de aviso.';
  @Input() icon: string = 'pi-check-circle'; // Clase para el ícono
  @Input() iconSize: string = '3rem'; // Tamaño del ícono
  @Input() iconColor: string = '#28a745'; // Color del ícono | Acepta hex o clases Tailwind
  @Input() buttonLabel: string = 'Cerrar'; // Texto del botón
  @Input() buttonClass: string = 'btn-primary'; // Clase del botón
  @Input() navigateTo: string | null = null; // Ruta a redirigir
  @Input() routeParam: string | number | null = null; // Parámetro dinámico de la ruta

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() onClose = new EventEmitter<void>();

  ngOnInit() {

   if (!this.onClose.observed) {
      this.subscription.add(
        this.mainService.notification$.subscribe(options => {
          this.title = options.title;
          this.message = options.message;
          this.icon = options.icon;
          this.iconColor = options.color;
          this.visible = true;
        })
      );
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  // Método para determinar si el color es una clase de Tailwind
  isTailwindColor(color: string): boolean {
    return !color.startsWith('#') && !color.startsWith('rgb') && !color.startsWith('hsl');
  }

  onAcceptAction() {
    this.visible = false;
  }

   onConfirm() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
    this.onClose.emit();

    if (this.navigateTo) {
      const route = this.routeParam ? `${this.navigateTo}/${this.routeParam}` : this.navigateTo;
      this.router.navigate([route]);
    }
  }
}
